/* unplugin-vue-components disabled */import script from "./AboutCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutCompany.vue?vue&type=script&setup=true&lang=js"

import "./AboutCompany.vue?vue&type=style&index=0&id=74fde131&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74fde131"]])

export default __exports__